import React, {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import TableListPaging from '@app/components/TableListPaging';
import CampaignRecipientTable from '@pages/Campaign/CampaignRecipientTable';
import DraftPreviewModal from '@pages/job/runjob/DraftPreviewModal';
import {requestListCampaignRecipients} from '@app/services/MailService';

const CampaignDetail = ({match}) => {
    const {campaignId} = match.params;
    const [recipients, setRecipients] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [hasNext, setHasNext] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [failedOnly, setFailedOnly] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [showDraftPreview, setShowDraftPreview] = useState(false);

    const fetchRecipients = async (page, failed = failedOnly) => {
        setIsLoading(true)
        try {
            const data = await requestListCampaignRecipients(campaignId, page, failed);
            setRecipients(data.results || []);
            setTotalCount(data.count || 0);
            setHasNext(Boolean(data.next));
        } catch (err) {
            toast.error('Không tải được danh sách recipient!')
        } finally {
            setIsLoading(false)
        }
    };

    useEffect(() => {
        fetchRecipients(currentPage)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    const nextPage = () => {
        if (hasNext) {
            setCurrentPage(currentPage + 1)
        }
    };

    const backPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1)
        }
    };

    const onToggleFailedOnly = () => {
        const next = !failedOnly
        setFailedOnly(next)
        setSelectedIds([])
        setCurrentPage(1)
        fetchRecipients(1, next)
    };

    const onToggle = (recipient) => {
        setSelectedIds(prev => prev.includes(recipient.id)
            ? prev.filter(id => id !== recipient.id)
            : [...prev, recipient.id])
    };

    const onToggleAll = () => {
        const selectable = recipients.filter(r => r.candidate_id)
        const allSelected = selectable.length > 0 && selectable.every(r => selectedIds.includes(r.id))
        setSelectedIds(allSelected ? [] : selectable.map(r => r.id))
    };

    // candidateIds duy nhất từ các recipient được chọn (retry cần candidateIds cho DraftPreview)
    const selectedCandidateIds = [...new Set(
        recipients.filter(r => selectedIds.includes(r.id) && r.candidate_id).map(r => r.candidate_id)
    )];

    const openRetry = () => {
        if (selectedCandidateIds.length === 0) return
        setShowDraftPreview(true)
    };

    const onCloseDraftPreview = () => {
        setShowDraftPreview(false)
        // refresh lại danh sách sau khi retry
        fetchRecipients(currentPage)
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold mt-2">Chi tiết Campaign #{campaignId} ({totalCount})</h3>
                <div className={'card-tools row'}>
                    <div className={"mt-2 ml-2"}>
                        <label className={"mb-0"} style={{fontWeight: 'normal', cursor: 'pointer'}}>
                            <input type="checkbox"
                                   className={"mr-1"}
                                   checked={failedOnly}
                                   onChange={onToggleFailedOnly}/>
                            Chỉ hiện thất bại
                        </label>
                    </div>
                    <div className={"mt-2 ml-3"}>
                        <button type={"button"}
                                className={"btn btn-primary btn-sm"}
                                disabled={selectedCandidateIds.length === 0}
                                onClick={openRetry}>
                            Retry ({selectedCandidateIds.length})
                        </button>
                    </div>
                    <div className={"mt-2 ml-2"}>
                        <TableListPaging onBack={backPage} onNext={nextPage}/>
                    </div>
                </div>
                {isLoading &&
                <div className={'col-sm-12 text-center'}
                     style={{
                         position: 'absolute',
                         top: '50%',
                         left: '50%',
                         transform: 'translate(-50%, -50%)'
                     }}>
                    <div className='spinner-grow text-primary' role='status'>
                        <span className='sr-only'>Loading...</span>
                    </div>
                </div>
                }
            </div>
            <div className="card-body p-0">
                <CampaignRecipientTable
                    recipients={recipients}
                    selectable
                    selectedIds={selectedIds}
                    onToggle={onToggle}
                    onToggleAll={onToggleAll}
                />
            </div>

            <DraftPreviewModal
                isShow={showDraftPreview}
                campaignId={campaignId}
                candidateIds={selectedCandidateIds}
                onClose={onCloseDraftPreview}
                // [SPEC: TEST Gửi Email qua PM - DVTJCUV 5 - BS2] luồng UV
                isRec={false}
            />
        </div>
    );
};

export default CampaignDetail;
